import React, { Component } from 'react'
import { assessorActivity } from 'constants/wizards'
import { meta } from 'helpers/decorators'
import { Wizard } from 'components/masters'
import { WizardProgress } from '../../../../components/layout'
import { renderRoutes } from 'react-router-config'

@meta({
  title: 'Register assessor activity',
  intlKey: 'pageTitle.register_assessor_activity'
})
class Activity extends Component {
  render() {
    const { route } = this.props
    const children = route && renderRoutes(route.routes)

    return (
      <Wizard
        items={assessorActivity}
        wizardProgress={<WizardProgress {...this.props} />}
        {...this.props}
      >
        {children}
      </Wizard>
    )
  }
}

export default Activity
